const PropTypes = require('prop-types');
// @vendor
const React = require('react');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');

// @commons
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @components
const CreditHeader = require('components/credits/creditHeader/creditHeader');
const CreditSituation = require('components/credits/creditSituation/creditSituation');
const { CreditInformation } = require('components/credits/creditInformation/creditInformation');

// @constants
const { LOANS_MORTGAGES_INVESTMENT_CREDIT } = require('constants/index');

class CreditGeneralData extends React.Component {

    getAssociatedTitle(immCredit) {
        switch (immCredit.get('type')) {
            case LOANS_MORTGAGES_INVESTMENT_CREDIT:
                return 'investmentCredits-headerTitle';
            default:
                return 'credits-headerTitle';
        }
    }

    buildBreadcrum(immCredit) {
        switch (immCredit.get('type')) {
            case LOANS_MORTGAGES_INVESTMENT_CREDIT:
                return [
                    {
                        text: formatText('breadcrumb-home'),
                        url: '/myprofile/'
                    },
                    {
                        text: formatText('breadcrumb-loansAndMortgages'),
                        url: '/myprofile/loans-mortgages/'
                    },
                    {
                        text: formatText('breadcrumb-credit'),
                    }
                ];
            default:
                return [
                    {
                        text: formatText('breadcrumb-credits'),
                        url: '/myprofile/loans-mortgages/'
                    },
                    {
                        text: formatText('breadcrumb-pregrantedCredit', [getLastNChars(immCredit.get('iban'), 4, '.', 4)])
                    }
                ];
        }
    }

    buildCreditSituation() {
        const { immCredit, showCreditSituation } = this.props;
        let creditSituation;

        if (showCreditSituation) {
            const immCreditSituation = immCredit.get('creditSituation');

            creditSituation = <CreditSituation immCreditSituation={immCreditSituation} />;
        }

        return creditSituation;
    }

    buildError() {
        const primaryText = formatText('credits-errorMessage');
        const handleClick = this.getCreditInformation;

        const retryButton = (
            <OKButton
                onClick={handleClick}
            >
                <FormattedText value="credits-retry" />
            </OKButton>
        );

        return (
            <OKSectionBox>
                <EmptyState
                    primaryText={primaryText}
                    button={retryButton}
                    iconType="nointernet-banking" />
            </OKSectionBox>
        );
    }

    render() {
        const { immCredit, immInterveners, getInformation, path } = this.props;
        const breadcrumb = this.buildBreadcrum(immCredit);
        const headerTitle = this.getAssociatedTitle(immCredit);
        const creditSituation = this.buildCreditSituation();
        const commercialAdsPath = path.includes('investment-credit') ? 'loans-mortgages/credit/investment-credit/:creditId' : 'loans-mortgages/credit/pregranted-credit/:creditId';

        return (
            <div className="credit-general-data">
                <div className="container-fluid">
                    <div className="row">
                        <CreditHeader
                            titleKey={headerTitle}
                            breadcrumbConfig={breadcrumb}
                            immCredit={immCredit}
                        />
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12 col-md-9">
                                <div className="credit-general-data__information-container">
                                    <CreditInformation immCredit={immCredit} immInterveners={immInterveners} getInformation={getInformation} />
                                </div>
                                {creditSituation}
                            </div>
                            <div className="col-xs-12 col-md-3 grid-view--variable-cell-separation">
                                <CommercialAds path={commercialAdsPath} type="banner-b" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CreditGeneralData.propTypes = {
    getInformation: PropTypes.func.isRequired,
    immCredit: PropTypes.object.isRequired,
    immInterveners: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired,
    showCreditSituation: PropTypes.bool
};

CreditGeneralData.defaultProps = {
    showCreditSituation: false
};

module.exports = CreditGeneralData;
